export const PIXEL_VALUE_REG_EXP = /^(\d+(?:\.\d+)?)px$/

export const COLUMN_WIDTH = 75
